import { createSlice } from "@reduxjs/toolkit";

const publishedSolutionsSlice = createSlice({
  name: "publishedSolutions",

  initialState: {
    items: [],
    loading: false,

    publishing: false,
    updating: false,
    deleting: false,

    publishSuccess: false,

    error: null,
  },

  reducers: {
    // =========================
    // FETCH PUBLISHED SOLUTIONS
    // =========================
    fetchPublishedRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchPublishedSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload || [];
    },

    fetchPublishedFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // =========================
    // PUBLISH DRAFT
    // =========================
    publishSolutionRequest: (state) => {
      state.publishing = true;
      state.publishSuccess = false;
      state.error = null;
    },

    publishSolutionSuccess: (state) => {
      state.publishing = false;
      state.publishSuccess = true;
    },

    publishSolutionFailure: (state, action) => {
      state.publishing = false;
      state.error = action.payload;
    },

    // =========================
    // UPDATE PUBLISHED SOLUTION
    // =========================
    updatePublishedSolutionRequest: (state) => {
      state.updating = true;
      state.error = null;
    },

    updatePublishedSolutionSuccess: (state) => {
      state.updating = false;
    },

    updatePublishedSolutionFailure: (state, action) => {
      state.updating = false;
      state.error = action.payload;
    },

    // =========================
    // DELETE PUBLISHED SOLUTION
    // =========================
    deletePublishedSolutionRequest: (state) => {
      state.deleting = true;
      state.error = null;
    },

    deletePublishedSolutionSuccess: (state) => {
      state.deleting = false;
    },

    deletePublishedSolutionFailure: (state, action) => {
      state.deleting = false;
      state.error = action.payload;
    },

    // =========================
    // RESET
    // =========================
    resetPublishedState: (state) => {
      state.publishing = false;
      state.publishSuccess = false;

      state.updating = false;
      state.deleting = false;

      state.error = null;
    },
    resetPublishedState: (state) => {
      state.items = [];
      state.loading = false;

      state.publishing = false;
      state.updating = false;
      state.deleting = false;

      state.publishSuccess = false;

      state.error = null;
    },
  },
});

export const {
  fetchPublishedRequest,
  fetchPublishedSuccess,
  fetchPublishedFailure,

  publishSolutionRequest,
  publishSolutionSuccess,
  publishSolutionFailure,

  updatePublishedSolutionRequest,
  updatePublishedSolutionSuccess,
  updatePublishedSolutionFailure,

  deletePublishedSolutionRequest,
  deletePublishedSolutionSuccess,
  deletePublishedSolutionFailure,

  resetPublishedState,
} = publishedSolutionsSlice.actions;

export default publishedSolutionsSlice.reducer;